<template>
  <div class="tag">
    <div @click="openTab(tag.type)" role="button">
      {{ tag.name | clean }}
      <span v-if="hasDuplicateTag">({{ tagName }})</span>
    </div>

    <span
      v-if="isSkillTag"
      class="tooltiptext">
      Minst {{skillLevel}} erfarenhet
    </span>

    <span
      v-if="isExperienceTag"
      class="tooltiptext">
      {{ yearGtModifier }} - {{ yearLtModifier }} år
    </span>

    <span v-if="hasSubject" class="tag__subject">
      ({{ hasSubject }})
    </span>

    <span
      v-if="isEducationTag"
      class="tooltiptext">
      Minst {{ yearGtModifier }} år
    </span>

    <div
      class="remove-wrap"
      role="button"
      @click="remove(tag)">
      <icon class="remove" fill="white" :size="16" type="times"></icon>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon'
import { SET_ACTIVE_TAB_ONLY, REMOVE_FROM_QUERY } from '@/store/actionTypes'

export default {
  name: 'SearchTag',

  components: {
    Icon
  },

  props: {
    tag: {
      required: true,
      type: Object
    }
  },

  computed: {
    isExperienceTag() {
      return this.tag.type === 'experiences' && this.yearGtModifier
    },

    isEducationTag() {
      return this.tag.type === 'educations' && this.yearGtModifier
    },

    isSkillTag() {
      return this.tag.type === 'skills'
    },

    hasSubject() {
      return this.tag.subject && this.tag.subject.name
    },

    yearGtModifier() {
      return this.tag.years.length > 0 && this.tag.years[0].years
    },

    yearLtModifier() {
      if (!this.tag.years[1] || this.tag.years[1].years === 10) {
        return 'över 10'
      }

      return this.tag.years[1].years
    },

    skillLevel() {
      return !!this.yearGtModifier ? `${this.yearGtModifier} års` : 'någon'
    },

    hasDuplicateTag() {
      if (this.tag.type === 'experiences' || this.tag.type === 'skills') {
        return this.$store.getters.hasDuplicateTag(this.tag.name)
      }

      return false
    },

    tagName() {
      switch (this.tag.type) {
        case 'experiences':
          return 'Yrke'
        case 'skills':
          return 'Kompetens'
        default:
          return ''
      }
    }
  },

  filters: {
    clean: tag => {
      if (!tag) {
        return ''
      }

      const hasParenthesis = tag.indexOf('(')

      if (hasParenthesis !== -1) {
        return tag.substr(0, hasParenthesis)
      }

      return tag
    }
  },

  methods: {
    remove({ type, path, subject, value }) {
      let payload = { type, path, value }

      if (type === 'educations' && subject && subject.path) {
        payload = {
          type,
          path,
          subject: {
            path: subject.path
          }
        }
      }

      window.eventBus.$emit('removeTag', payload)
      this.$store.commit(REMOVE_FROM_QUERY, payload)
    },
    openTab(type) {
      if (
        type === 'hasAtUnd' ||
        type === 'seekingAsylum' ||
        type === 'hasResidencePermit'
      ) {
        type = 'asylumStatus'
      }

      this.$store.commit(SET_ACTIVE_TAB_ONLY, type)
    }
  }
}
</script>

<style lang="postcss" scoped>
.tag {
  align-items: center;
  background-color: var(--color-blue-dianne);
  border-radius: 3px;
  color: var(--color-white);
  display: flex;
  font-size: 14px;
  font-weight: bold;
  padding: var(--spacing-third);
  position: relative;
  margin-bottom: var(--spacing-third);

  &:not(:last-child) {
    margin-right: var(--spacing-third);
  }

  @supports (-ms-ime-align: auto) {
    &:not(:last-child) {
      margin-bottom: var(--spacing-third);
    }
  }
}

.tag__subject {
  margin-left: 5px;
}

.remove-wrap {
  cursor: pointer;
  display: flex;
  margin-left: var(--spacing-third);
}

.remove {
  opacity: 1;
  transition: opacity 150ms ease-in-out;

  &:hover {
    opacity: 0.8;
  }
}

/* Tooltip text */
.tag .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: var(--color-white);
  color: var(--color-mine-shaft);
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  top: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 300ms;
}

/* Tooltip arrow */
.tag .tooltiptext:after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent var(--color-white) transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tag:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchTag.vue